export default __webpack_public_path__ + "static/media/logo.9b59ff4c.png";